/**
 * @author        matthew@zumper.com (Matthew Talamini)
 * @copyright     Copyright (c) 2024, Zumper
 * @description   BuildingReviewsData meta reducer
 */

import type { BuildingReviewsDataMetaType } from '@zcode/bizos'
import {
  falseReducer,
  nullReducer,
  payloadKeyReducer,
  payloadReducer,
  trueReducer,
} from '@zcode/reducers'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import {
  CLEAR_BUILDING_REVIEWS_DATA,
  DONE_FETCHING_BUILDING_REVIEWS_DATA,
  ERROR_FETCHING_BUILDING_REVIEWS_DATA,
  START_FETCHING_BUILDING_REVIEWS_DATA,
} from '../constants/index'
import type { ActionTypes } from './types'

export const metaReducer = combineReducers<BuildingReviewsDataMetaType, ActionTypes>({
  error: handleActions<BuildingReviewsDataMetaType['error'], ActionTypes>(
    {
      [ERROR_FETCHING_BUILDING_REVIEWS_DATA]: payloadReducer,
      [CLEAR_BUILDING_REVIEWS_DATA]: nullReducer,
      [START_FETCHING_BUILDING_REVIEWS_DATA]: nullReducer,
    },
    null
  ),
  fetching: handleActions(
    {
      [START_FETCHING_BUILDING_REVIEWS_DATA]: trueReducer,
      [CLEAR_BUILDING_REVIEWS_DATA]: falseReducer,
      [DONE_FETCHING_BUILDING_REVIEWS_DATA]: falseReducer,
    },
    false
  ),
  fetchingKey: handleActions<BuildingReviewsDataMetaType['fetchingKey'], ActionTypes>(
    {
      [START_FETCHING_BUILDING_REVIEWS_DATA]: payloadKeyReducer('key'),
      [CLEAR_BUILDING_REVIEWS_DATA]: nullReducer,
      [DONE_FETCHING_BUILDING_REVIEWS_DATA]: nullReducer,
    },
    null
  ),
  currentKey: handleActions<BuildingReviewsDataMetaType['currentKey'], ActionTypes>(
    {
      [CLEAR_BUILDING_REVIEWS_DATA]: nullReducer,
      [DONE_FETCHING_BUILDING_REVIEWS_DATA]: (state, { payload }) => payload?.key ?? state,
    },
    null
  ),
})
